
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcRadio as ObcRadioElement} from '@oicl/openbridge-webcomponents/dist/components/radio/radio.js';
 
 
 

 
 export const ObcRadio = createComponent({
   react: React,
   tagName: 'obc-radio',
   elementClass: ObcRadioElement,
   events: {
     
     onChange: 'change' as EventName<CustomEvent<unknown>>,
   }
  });
 
 